import { reactive } from "vue";

const DEFAULT_LOCALE = "en";
const SUPPORTED_LOCALES = ["en", "pt"];

const messages = {
  en: {
    app: {
      logoAlt: "Jorge Castanho Lda logo",
    },
    nav: {
      logoAlt: "Jorge Castanho Lda logo",
      company: "The Company",
      portfolio: "Portfolio",
      contact: "Contact",
      requestQuote: "Request Quote",
      toggleNavigation: "Toggle navigation",
      switchToEnglish: "Switch language to English",
      switchToPortuguese: "Switch language to Portuguese",
      languageSwitcher: "Language switcher",
      languageEnglish: "EN",
      languagePortuguese: "PT",
    },
    footer: {
      description: "Premium aluminum mold manufacturing from Marinha Grande, Portugal.",
      copyright: "© 2026 Jorge Castanho Lda. All rights reserved.",
    },
    home: {
      heroImageAlt: "Precision mold finishing",
      kicker: "Jorge Castanho Lda",
      title: "High-Performance Aluminum Mold Manufacturing",
      lead:
        "For over 30 years, we have shaped precision aluminum tools for demanding industries with consistent quality, reliable lead times, and expert technical support.",
      explorePortfolio: "Explore Portfolio",
      startProject: "Start Your Project",
      statsYearsTitle: "30+ Years",
      statsYearsBody: "Specialized mold manufacturing heritage.",
      statsWeightTitle: "Up to 10 Tons",
      statsWeightBody: "Large-format tooling capability.",
      statsFlowTitle: "Prototype to Serial",
      statsFlowBody: "Flexible production for every stage.",
      story1ImageAlt: "High-capacity industrial machining floor",
      story1Tag: "Engineering Depth",
      story1Title: "Built for demanding industries",
      story1Body:
        "We develop and manufacture high-quality aluminum molds for automotive, aerospace, consumer goods, and other technical sectors where repeatability matters.",
      story2ImageAlt: "Precision mold detailing",
      story2Tag: "Quality Focus",
      story2Title: "Durable, precise, and reliable tooling",
      story2Body:
        "Every project is executed with close process control and detail-oriented finishing, ensuring robust mold performance from first run to long-term production.",
      story3ImageAlt: "CNC equipment in operation",
      story3Tag: "Production Capability",
      story3Title: "Scalable output for your timeline",
      story3Body:
        "From rapid prototypes to serial tools, we support your production goals with dependable planning, transparent communication, and fast technical response.",
      processTitle: "How we work",
      processLead: "A direct process designed to keep projects efficient and predictable.",
      process1ImageAlt: "Technical assessment meeting room",
      process1Title: "01. Technical Assessment",
      process1Body: "We review requirements, tolerances, and performance targets with your team.",
      process2ImageAlt: "Precision machining process",
      process2Title: "02. Precision Manufacturing",
      process2Body: "Our machining and finishing workflow is optimized for durability and repeatability.",
      process3ImageAlt: "Validated finished samples ready for release",
      process3Title: "03. Validation & Delivery",
      process3Body:
        "Each tool is checked and prepared for release so you receive a mold ready for production.",
      ctaImageAlt: "Company facility exterior",
      ctaTitle: "Ready to shape your next mold project?",
      ctaBody: "Share your technical goals and we will help define the right tooling approach.",
      ctaButton: "Contact Our Team",
    },
    about: {
      eyebrow: "Contact",
      title: "Let's Build Your Next Aluminum Tool",
      lead:
        "Talk with our team about your mold requirements, production targets, and timeline. We are ready to support your project from concept to delivery.",
      imageAlt: "Jorge Castanho logo at facility",
      addressTitle: "Address",
      telephoneTitle: "Telephone",
      emailTitle: "E-mail",
      mapTitle: "Jorge Castanho Lda location",
    },
    portfolio: {
      heroImageAlt: "Portfolio highlight",
      eyebrow: "Portfolio",
      title: "Crafted Tools, Proven Results",
      lead:
        "A selection of projects that reflects our manufacturing precision, finishing quality, and production versatility.",
      imageAlt: "Portfolio manufacturing project",
      closeImage: "Close image",
      previousImage: "Previous image",
      nextImage: "Next image",
    },
  },
  pt: {
    app: {
      logoAlt: "Logótipo Jorge Castanho Lda",
    },
    nav: {
      logoAlt: "Logótipo Jorge Castanho Lda",
      company: "A Empresa",
      portfolio: "Portefólio",
      contact: "Contacto",
      requestQuote: "Pedir Orçamento",
      toggleNavigation: "Alternar navegação",
      switchToEnglish: "Mudar idioma para inglês",
      switchToPortuguese: "Mudar idioma para português",
      languageSwitcher: "Seletor de idioma",
      languageEnglish: "EN",
      languagePortuguese: "PT",
    },
    footer: {
      description: "Fabrico premium de moldes em alumínio na Marinha Grande, Portugal.",
      copyright: "© 2026 Jorge Castanho Lda. Todos os direitos reservados.",
    },
    home: {
      heroImageAlt: "Acabamento de moldes de precisão",
      kicker: "Jorge Castanho Lda",
      title: "Fabrico de Moldes em Alumínio de Alto Desempenho",
      lead:
        "Há mais de 30 anos que desenvolvemos ferramentas de alumínio de precisão para indústrias exigentes, com qualidade consistente, prazos fiáveis e apoio técnico especializado.",
      explorePortfolio: "Ver Portefólio",
      startProject: "Iniciar Projeto",
      statsYearsTitle: "30+ Anos",
      statsYearsBody: "Tradição especializada no fabrico de moldes.",
      statsWeightTitle: "Até 10 Toneladas",
      statsWeightBody: "Capacidade para ferramentas de grande formato.",
      statsFlowTitle: "Protótipo a Série",
      statsFlowBody: "Produção flexível para cada fase.",
      story1ImageAlt: "Área industrial de maquinação de grande capacidade",
      story1Tag: "Engenharia Profunda",
      story1Title: "Preparados para indústrias exigentes",
      story1Body:
        "Desenvolvemos e fabricamos moldes em alumínio de elevada qualidade para os setores automóvel, aeroespacial, bens de consumo e outras áreas técnicas onde a repetibilidade é essencial.",
      story2ImageAlt: "Detalhe de molde de precisão",
      story2Tag: "Foco na Qualidade",
      story2Title: "Ferramentas duráveis, precisas e fiáveis",
      story2Body:
        "Cada projeto é executado com controlo rigoroso de processo e acabamento orientado ao detalhe, garantindo desempenho robusto do molde desde o primeiro ciclo até à produção prolongada.",
      story3ImageAlt: "Equipamento CNC em operação",
      story3Tag: "Capacidade de Produção",
      story3Title: "Produção escalável para o seu prazo",
      story3Body:
        "De protótipos rápidos a ferramentas de série, apoiamos os seus objetivos de produção com planeamento fiável, comunicação transparente e resposta técnica rápida.",
      processTitle: "Como trabalhamos",
      processLead: "Um processo direto para manter os projetos eficientes e previsíveis.",
      process1ImageAlt: "Sala de reunião para avaliação técnica",
      process1Title: "01. Avaliação Técnica",
      process1Body: "Analisamos requisitos, tolerâncias e metas de desempenho com a sua equipa.",
      process2ImageAlt: "Processo de maquinação de precisão",
      process2Title: "02. Fabrico de Precisão",
      process2Body: "O nosso fluxo de maquinação e acabamento é otimizado para durabilidade e repetibilidade.",
      process3ImageAlt: "Amostras finais validadas prontas para entrega",
      process3Title: "03. Validação e Entrega",
      process3Body:
        "Cada ferramenta é verificada e preparada para expedição para que receba um molde pronto para produção.",
      ctaImageAlt: "Exterior das instalações da empresa",
      ctaTitle: "Pronto para avançar com o seu próximo projeto de molde?",
      ctaBody: "Partilhe os seus objetivos técnicos e ajudamos a definir a abordagem de ferramenta certa.",
      ctaButton: "Contactar a Equipa",
    },
    about: {
      eyebrow: "Contacto",
      title: "Vamos Construir a Sua Próxima Ferramenta em Alumínio",
      lead:
        "Fale com a nossa equipa sobre os requisitos do seu molde, metas de produção e prazos. Estamos prontos para apoiar o seu projeto desde o conceito até à entrega.",
      imageAlt: "Logótipo Jorge Castanho nas instalações",
      addressTitle: "Morada",
      telephoneTitle: "Telefone",
      emailTitle: "E-mail",
      mapTitle: "Localização da Jorge Castanho Lda",
    },
    portfolio: {
      heroImageAlt: "Destaque do portefólio",
      eyebrow: "Portefólio",
      title: "Ferramentas Produzidas, Resultados Comprovados",
      lead:
        "Uma seleção de projetos que reflete a nossa precisão de fabrico, qualidade de acabamento e versatilidade de produção.",
      imageAlt: "Projeto de fabrico de moldes do portefólio",
      closeImage: "Fechar imagem",
      previousImage: "Imagem anterior",
      nextImage: "Imagem seguinte",
    },
  },
};

const state = reactive({
  locale: DEFAULT_LOCALE,
});

function normalizeLocale(locale) {
  if (!locale) {
    return DEFAULT_LOCALE;
  }

  const lowered = String(locale).toLowerCase();

  if (lowered.startsWith("pt")) {
    return "pt";
  }

  if (lowered.startsWith("en")) {
    return "en";
  }

  return DEFAULT_LOCALE;
}

function updateHtmlLang(locale) {
  if (typeof document === "undefined") {
    return;
  }

  document.documentElement.lang = locale === "pt" ? "pt-PT" : "en";
}

function loadStoredLocale() {
  if (typeof window === "undefined") {
    return null;
  }

  try {
    return window.localStorage.getItem("site-locale");
  } catch (error) {
    return null;
  }
}

function saveStoredLocale(locale) {
  if (typeof window === "undefined") {
    return;
  }

  try {
    window.localStorage.setItem("site-locale", locale);
  } catch (error) {
    // Ignore storage write errors (private mode or restricted storage).
  }
}

export function setLocale(locale) {
  const normalized = normalizeLocale(locale);

  if (!SUPPORTED_LOCALES.includes(normalized)) {
    return;
  }

  state.locale = normalized;
  updateHtmlLang(normalized);
  saveStoredLocale(normalized);
}

export function initializeLocale() {
  const stored = loadStoredLocale();
  const initialLocale = stored || DEFAULT_LOCALE;

  setLocale(initialLocale);
}

export function t(key) {
  const localeMessages = messages[state.locale] || messages[DEFAULT_LOCALE];
  const segments = key.split(".");

  let value = localeMessages;
  for (const segment of segments) {
    if (value && Object.prototype.hasOwnProperty.call(value, segment)) {
      value = value[segment];
    } else {
      value = null;
      break;
    }
  }

  if (typeof value === "string") {
    return value;
  }

  // Fallback to English when a key is missing in the selected locale.
  let fallback = messages[DEFAULT_LOCALE];
  for (const segment of segments) {
    if (fallback && Object.prototype.hasOwnProperty.call(fallback, segment)) {
      fallback = fallback[segment];
    } else {
      return key;
    }
  }

  return typeof fallback === "string" ? fallback : key;
}

export const i18nState = state;
